<form class="form">
      <mat-form-field class="full-width">
            <mat-label>{{placeholder}}</mat-label>
            <input type="text" placeholder="{{ placeholder }}" matInput [formControl]="myControl"
                  [matAutocomplete]="auto" />
            @if (myControl.errors && myControl.hasError('invalid') ) {
            <mat-error>You should select at least one entity.</mat-error>
            }
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn"
                  (optionSelected)='notifySelected($event.option.value);'>
                  @for (option of filteredOptions | async; track option; let i = $index) {
                  <mat-option class="custom-mat-option" [value]="option"
                        innerHTML='{{ option["Display"] }} {{ detailsColumn != null && option[detailsColumn] != "" ? (" (" + option[detailsColumn] + ")") : "" }}'>
                  </mat-option>
                  }
            </mat-autocomplete>
            @if (myControl.value && !myControl.disabled) {
            <button type="button" matSuffix mat-icon-button aria-label="Clear" (click)="reset(); notifySelected(null);">
                  <mat-icon>close</mat-icon>
            </button>
            }
            @if (hasErrorMessage && myControl.errors && myControl.hasError('required')) {
            <mat-error>{{ errorMessage }}</mat-error>
            }
      </mat-form-field>
</form>